import {
  type AppError,
  ERROR_CODES,
  ErrorCode,
  ErrorMessage,
  INFO_CODES,
  WARNING_CODES,
} from '@imprivata-cloud/authn';
import {
  DEFAULT_BANNER_STATUS,
  type NOTIF_BANNER_TYPE,
} from '@imprivata-cloud/components';
import type { UIEventBody } from '@imprivata-cloud/core';

// TODO: Normalize into Error codes
export const IGNORED_ERROR_MESSAGES: Array<ErrorMessage | string> = [
  ErrorMessage.NOT_ENROLLED_CARD,
];

export const IGNORED_ERROR_CODES: Array<ErrorCode> = [
  ErrorCode.LOW_QUALITY,
  ErrorCode.NO_FACE_DETECTED,
  ErrorCode.FACE_LIMIT,
  ErrorCode.DUPLICATE,
];
export const mapErrorToStatus = (error: AppError): NOTIF_BANNER_TYPE => {
  const { code } = error;
  if (!code) {
    return DEFAULT_BANNER_STATUS;
  }

  if (INFO_CODES.includes(code)) {
    return 'info';
  }

  if (WARNING_CODES.includes(code)) {
    return 'warning';
  }

  if (ERROR_CODES.includes(code)) {
    return 'error';
  }

  return DEFAULT_BANNER_STATUS;
};

// Error-severity banners are shown with warning styling — a softer amber rather
// than an alarming red. This mirrors the pre-unification behavior, where each
// render site downgraded `error` to `warning` at the banner's `type` prop while
// the true severity stayed available to the enrollment header's glyph. Apply it
// only to the emitted banner status, never to the value that drives the glyph.
export const toDisplayStatus = <T extends string>(level: T): T =>
  (level === 'error' ? 'warning' : level) as T;

export const DISPLAY_BANNER_TIME = 20; //secs

export const offlineBannerMetaData = (
  title: string,
  message: string,
): UIEventBody => ({
  level: 'warning',
  title,
  message,
  closeTimeInSec: DISPLAY_BANNER_TIME,
});
